import * as React from "react";

import { Experiment, Variant } from "client/components";
import { LoginForm } from "client/domain";

import { LoginFormVariant, ValuePropsVariant } from "./ValueProps";

export const LoginFormExperiment: React.FC = () => (
  <Experiment
    fallback={<LoginForm />}
    flag="merchantPortalExperimentLoginVariants"
  >
    <Variant type="Control">
      <LoginForm />
    </Variant>
    <Variant type="ValueProps">
      <ValuePropsVariant />
    </Variant>
    <Variant type="UpdatedLegacy">
      <LoginFormVariant leftAlign={false} />
    </Variant>
  </Experiment>
);
